import { errorMessagesSection, faExclamationCircle, FormStyle,
         infoPlaceholderSection, React} from "@/imports-files/components/custom-datetime";
import "react-datetime/css/react-datetime.css";
import "react-time-picker-input/dist/components/TimeInput.css"
import TimeInput from  "react-time-picker-input";


export function TimePickerInput(props)
{
  return(
    <React.Fragment>
      <TimeInput {...props}/>
      {   
        props?.inputProps?.style != undefined ?  errorMessagesSection( props?.name, FormStyle, props?.formik, props?.custom_class || '', props?.custom_error_90 || '')
                                              :  infoPlaceholderSection( props?.infoPlaceholder, FormStyle) 
      }
       
    </React.Fragment>
  )
}